import Layout from '../layout-components/Layout';
import { routePaths } from '../../shared/config/globalConfig';

//
/**
 * The `ThemedRoute` component conditionally renders either a regular `Route` with the provided `Component`
 * or a `Route` wrapped in a `Layout` component, depending on whether the path includes specific patterns
 * related to trails, project verification, or iframes.
 * @returns {import('react').ReactElement}
 */
const ThemedRoute = ({ component: Component, noLayout = false, ...rest }) => {
  if (
    rest?.path?.includes('/trail') ||
    rest?.path?.includes(routePaths.veryfyProject) ||
    rest?.path?.includes(routePaths.iFrame) ||
    noLayout
  ) {
    return <Component />;
  } else {
    return (
      <Layout>
        <Component />
      </Layout>
    );
  }
};

export default ThemedRoute;
